<!--
  Product Position — add-new sub-modal.
  Redesigned 2026-06-11 (v2.7.0, Phase 1.5 Chunk B.3).

  Opened by clicking "Aggiungi posizione" in the ProductDetail
  modal. Native form (corsia / ripiano / scaffale / quantità) +
  native file upload with inline preview. Diakonix modal--md
  pattern.

  Drops kendo-dialog + kendo-formfield + kendo-label + kendo upload
  + ~25 inline `style="..."` attributes.
-->

@if (openPhoto) {
  <div class="modal-backdrop" (click)="goBack()">
    <aside class="modal modal--md" (click)="$event.stopPropagation()">

      <!-- ─── Header ─────────────────────────────────────────── -->
      <header class="modal__header">
        <h2 class="modal__title">
          📍 Aggiungi posizione
          @if (product?.pr_code) {
            <span class="modal__title-tag">{{ product.pr_code }}</span>
          }
        </h2>
        <button type="button" class="modal-close" (click)="close()" aria-label="Chiudi">×</button>
      </header>

      <!-- ─── Body ──────────────────────────────────────────── -->
      <form
        class="modal__body"
        [formGroup]="addProductPositionForm"
        (ngSubmit)="addProductPos()"
      >

        <!-- ── File upload zone ── -->
        <label class="upload-zone" [class.upload-zone--filled]="previewSrc">
          @if (previewSrc) {
            <img class="upload-zone__preview" [src]="previewSrc" alt="Anteprima posizione" />
            <span class="upload-zone__hint">Clicca per cambiare immagine</span>
          } @else {
            <span class="upload-zone__icon" aria-hidden="true">📷</span>
            <span class="upload-zone__title">Carica foto della posizione</span>
            <span class="upload-zone__hint">PNG, JPG o JPEG</span>
          }
          <input
            type="file"
            accept=".png,.jpg,.jpeg"
            class="upload-zone__input"
            (change)="onFileLoad($event)"
          />
        </label>

        @if (
          addProductPositionForm.get('pr_b64_image_position')?.touched &&
          addProductPositionForm.get('pr_b64_image_position')?.errors
        ) {
          <p class="form-error">⚠️ La foto è obbligatoria.</p>
        }

        <!-- ── Form grid ── -->
        <div class="form-grid">

          <div class="form-field form-field--full">
            <label class="form-field__label">N° / Nome prodotto</label>
            <input
              type="text"
              class="form-input form-input--readonly"
              [value]="product?.pr_description ?? '—'"
              readonly
            />
          </div>

          <div class="form-field">
            <label class="form-field__label" for="pp-lane">
              Corsia <span class="form-field__req">*</span>
            </label>
            <input
              id="pp-lane"
              type="text"
              class="form-input"
              formControlName="pr_lane"
              placeholder="Es. A"
            />
            @if (
              addProductPositionForm.get('pr_lane')?.touched &&
              addProductPositionForm.get('pr_lane')?.errors
            ) {
              <p class="form-error">⚠️ Corsia obbligatoria</p>
            }
          </div>

          <div class="form-field">
            <label class="form-field__label" for="pp-shelf">
              Ripiano <span class="form-field__req">*</span>
            </label>
            <input
              id="pp-shelf"
              type="text"
              class="form-input"
              formControlName="pr_shelf"
              placeholder="Es. 03"
            />
            @if (
              addProductPositionForm.get('pr_shelf')?.touched &&
              addProductPositionForm.get('pr_shelf')?.errors
            ) {
              <p class="form-error">⚠️ Ripiano obbligatorio</p>
            }
          </div>

          <div class="form-field">
            <label class="form-field__label" for="pp-position">
              Scaffale <span class="form-field__req">*</span>
            </label>
            <input
              id="pp-position"
              type="text"
              class="form-input"
              formControlName="pr_position"
              placeholder="Es. B2"
            />
            @if (
              addProductPositionForm.get('pr_position')?.touched &&
              addProductPositionForm.get('pr_position')?.errors
            ) {
              <p class="form-error">⚠️ Scaffale obbligatorio</p>
            }
          </div>

          <div class="form-field">
            <label class="form-field__label" for="pp-qty">
              Quantità <span class="form-field__req">*</span>
            </label>
            <input
              id="pp-qty"
              type="number"
              min="0"
              class="form-input"
              formControlName="pr_qty"
              placeholder="0"
            />
            @if (
              addProductPositionForm.get('pr_qty')?.touched &&
              addProductPositionForm.get('pr_qty')?.errors
            ) {
              <p class="form-error">⚠️ Quantità obbligatoria</p>
            }
          </div>
        </div>
      </form>

      <!-- ─── Footer ────────────────────────────────────────── -->
      <footer class="modal__footer">
        <button type="button" class="btn btn--ghost" (click)="close()">
          Annulla
        </button>
        <button
          type="button"
          class="btn btn--primary"
          (click)="addProductPos()"
          [disabled]="addProductPositionForm.invalid || loading"
        >
          @if (loading) { <span class="btn-spinner"></span> }
          + Aggiungi posizione
        </button>
      </footer>

    </aside>
  </div>
}
